// extracted by mini-css-extract-plugin
module.exports = {"clickableText":"order-notification__clickableText___16WkX","errorNotification":"order-notification__errorNotification___3XbDa"};